@if (_events.length > 0) {
  <div @expandHeight class="padding-sides-15">
    @for (event of _events; track event; let i = $index) {
      <div @expandHeight class="container">
        <div (click)="dismissForNow(i)" [attr.role]="isNotice(event) ? 'status' : 'alert'"
          class="banner flex-item" [class.notice]="isNotice(event)" [class.error]="!isNotice(event)">
          <h3>
            @if (isNotice(event)) {
              <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.notice' | transloco">info</mat-icon>
            } @else {
              <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.warning' | transloco">warning</mat-icon>
            }
            {{event.message}}
          </h3>
        </div>
        <div class="dismiss-split">
          <button mat-stroked-button class="dismiss-main" (click)="dismissForNow(i)">{{ 'common.labels.dismiss' | transloco }}</button>
          <button mat-stroked-button class="dismiss-toggle" [matMenuTriggerFor]="dismissMenu"
            [attr.aria-label]="'common.labels.moreDismissOptions' | transloco">
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </div>
        <mat-menu #dismissMenu="matMenu">
          <button mat-menu-item (click)="dismissForNow(i)">{{ 'common.labels.forNow' | transloco }}</button>
          <button mat-menu-item (click)="dismissForOneDay(event)">{{ 'common.labels.forADay' | transloco }}</button>
        </mat-menu>
      </div>
    }
  </div>
}